const anchorKey = Symbol("anchor");

export { anchorKey };
//# sourceMappingURL=constants.mjs.map
